import { useEffect } from 'react';
import { useSwiper } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/scrollbar';

type SwiperSlideToProps = {
	slideTo?: number;
};

export function SwiperSlideTo(props: SwiperSlideToProps): JSX.Element {
	const swiper = useSwiper();

	useEffect(() => {
		props.slideTo && swiper.slideTo(props.slideTo);
	}, [props.slideTo, swiper]);

	return <></>;
}
